export default function formatDate(date) {
  // Check if date is null or undefined
  if (!date) return ""; // Or any default value you prefer

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${day}/${month}/${year}`;
}
